import { api } from "@/api/client";
import type { EntityLookupValue } from "@/components/shared/EntityLookup";

export const INTERACAO_PATH = "instituicao/InstituicaoInteracao";

export type TipoInteracao = "SU" | "CB" | "CN" | "TR" | "CA" | "SA";

export interface Tela {
  telaId: number;
  tela: string;
}

export interface InstituicaoInteracao {
  id: number;
  dataInteracao: string;
  // A entidade Instituicao completa (mesmo objeto que o GET direto de
  // instituição devolve — inclui `descricao`, usado pelo <EntityLookup> pra
  // exibir o valor já selecionado ao editar/visualizar).
  instituicao: EntityLookupValue & { nomeFantasia: string };
  instituicaoId: number;
  usuarioResponsavel?: { nome: string };
  tipoInteracao: TipoInteracao;
  usuarioContato?: string;
  descricao: string;
  tela?: Tela;
  telaId?: number;
}

export interface InstituicaoInteracaoFiltro {
  dataInicial?: string;
  dataFinal?: string;
  descricao?: string;
  usuario?: string;
  tipoInteracao?: string;
  instituicao?: EntityLookupValue;
  instituicaoId?: number;
  tela?: Tela;
  telaId?: number;
}

export async function getInteracao(id: number): Promise<InstituicaoInteracao> {
  const { data } = await api.get<InstituicaoInteracao>(`${INTERACAO_PATH}/${id}`);
  return data;
}

export async function saveInteracao(registro: Partial<InstituicaoInteracao>): Promise<InstituicaoInteracao> {
  const { data } = await api.post<InstituicaoInteracao>(INTERACAO_PATH, registro);
  return data;
}

export async function deleteInteracao(id: number): Promise<void> {
  await api.delete(`${INTERACAO_PATH}/${id}`);
}

// Contrato específico de sp-lookup pra entidade "Telas"
// (app/directives/lookup/lookup.config.js): campos telaId/tela em vez de
// id/descricao, busca por id em .../Telas/Pesquisar/{id}, e permite criar um
// item novo digitando o nome livre na busca (addNew()).
const TELAS_PATH = "instituicao/Telas";

export async function buscarTela(id: number): Promise<Tela> {
  const { data } = await api.get<Tela>(`${TELAS_PATH}/Pesquisar/${id}`);
  return data;
}

export async function criarTela(descricao: string): Promise<Tela> {
  const { data } = await api.post<Tela>(TELAS_PATH, { descricao });
  return data;
}
